<template>

    <div class="element nested-element last-element white" v-bind:class="{'repo-dev': repo === 'dev'}" v-show="setExpanded">
        <div class="element-heading">
            <div class="element-name">

                <div class="display-name">{{ game.display_name }}</div>
                <div class="output-identification-name">{{ game.output_identification_name }} ({{ game.input_identification_name }})</div>

                <b-badge
                    pill
                    variant="primary"
                    v-if="game.presentation_game"
                    v-b-tooltip.hover
                    title="Gra personalizowana">
                    Personalizowana
                </b-badge>

                <b-badge
                    pill
                    variant="secondary"
                    v-if="game.autoenter"
                    v-b-tooltip.hover
                    title="Gra ma włączony autoenter">
                    Autoenter
                </b-badge>

                <b-badge
                    pill
                    variant="danger"
                    v-if="game.game_not_on_list"
                    v-b-tooltip.hover
                    title="Brak plików źródłowych gry w plikach repozytorium">
                    Brak źródeł
                </b-badge>

                <b-badge
                    pill
                    variant="warning"
                    v-if="game.config_was_updated_since_last_approve"
                    v-b-tooltip.hover
                    title="Konfiguracja została zaktualizowana od ostatniego zatwierdzenia">
                    Konfiguracja edytowana
                </b-badge>

                <b-badge
                    pill
                    variant="warning"
                    v-if="game.files_were_updated_since_last_approve"
                    v-b-tooltip.hover
                    title="Pliki źródłowe gry zostały zaktualizowane od ostatniego zatwierdzenia">
                    Źródła edytowane
                </b-badge>

                <b-badge
                    pill
                    variant="warning"
                    v-if="game.translations_were_updated_since_last_approve"
                    v-b-tooltip.hover
                    title="Tłumaczenia zostały zaktualizowane od ostatniego zatwierdzenia">
                    Tłumaczenia edytowane
                </b-badge>

            </div>
            <div class="element-buttons">

                <div class="buttons-row" v-show="!orderManagementState">

                    <b-button
                        size="xs"
                        variant="success"
                        v-if="game.need_approve"
                        @click="approveGame()">
                        Zatwierdź
                    </b-button>

                    <b-button
                        size="xs"
                        variant="info"
                        @click="showGameChangelog(game)">
                        Changelog
                    </b-button>

                    <b-button
                        size="xs"
                        variant="primary"
                        v-if="repo === 'dev' && game.editor !== null"
                        :href="route('game::game-editor.prepare-files', {gameId: game.id})">
                        Edytuj zawartość
                    </b-button>

                    <b-button
                        size="xs"
                        variant="warning"
                        v-if="repo === 'dev'"
                        @click="move">
                        Przenieś
                    </b-button>

                    <b-button
                        size="xs"
                        variant="primary"
                        v-if="repo === 'dev'"
                        @click="editGame">
                        Edytuj
                    </b-button>

                    <b-button
                        size="xs"
                        variant="danger"
                        @click="deleteGame">
                        Usuń
                    </b-button>

                </div>

                <div class="buttons-row" v-show="orderManagementState">

                    <a href="javascript:void(0);" class="text-primary up" v-show="repo === 'dev'" @click="moveUp" title="W górę"><i class="fa fa-chevron-up"></i></a>
                    <span>&nbsp;</span>
                    <a href="javascript:void(0);" class="text-primary down" v-show="repo === 'dev'" @click="moveDown" title="W dół"><i class="fa fa-chevron-down"></i></a>

                </div>

            </div>
        </div>

    </div>

</template>

<script>
    export default {

        name: 'GameLibraryGame',

        props: [
            'repo',
            'game',
            'library',
            'setExpanded',
            'orderManagementState',
            'packageLanguage'
        ],

        data() {
            return {
                eventHub: window.eventHub
            }
        },

        methods: {

            editGame() {
                this.eventHub.$emit('game-library-edit-game', this.game, this.packageLanguage);
            },

            deleteGame() {
                this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć grę: ' + this.game.display_name + '?' + (this.repo === 'prod' ? 'Jeśli gra zawiera materiały marketingowe, zostaną one również usunięte.' : ''), {
                    title: 'Usuń grę',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Usuń',
                    cancelTitle: 'Anuluj',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value) {
                            this.eventHub.$emit('processing-start');
                            axios.delete(route('game::game-library.delete-game', {repo: this.repo, id: this.game.id}))
                                .then(response => {
                                    this.eventHub.$emit('game-library-updated', response.data.data.library);
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                                })
                                .catch(error => {
                                    console.log(error);
                                    this.eventHub.$emit('processing-finish');
                                    this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                                });
                        }
                    });
            },

            approveGame() {
                if (this.game.translations_were_updated_since_last_approve) {
                    this.eventHub.$emit('game-library-show-approve-game-modal', this.game);
                } else {
                    this.eventHub.$emit('game-library-approve-element', 'game', {
                        id: this.game.id,
                        display_name: this.game.display_name,
                        updated_at: this.game.updated_at ? (new Date(this.game.updated_at)).toLocaleString() : '---',
                        approved_at: this.game.approved_at ? (new Date(this.game.approved_at)).toLocaleString() : '---',
                        files_updated_at: this.game.files_updated_at ? (new Date(this.game.files_updated_at)).toLocaleString() : '---',
                        translations_updated_at: this.game.translations_updated_at !== null ? (new Date(this.game.translations_updated_at)).toLocaleString() : '---',
                        files_were_updated_since_last_approve: this.game.files_were_updated_since_last_approve,
                        config_was_updated_since_last_approve: this.game.config_was_updated_since_last_approve,
                        translations_were_updated_since_last_approve: this.game.translations_were_updated_since_last_approve,
                    });
                }
            },

            move() {
                this.eventHub.$emit('game-library-move-element', 'game', this.game);
            },

            moveUp() {
                // Get index of element
                let setIndex;
                let packageIndex;
                let gameIndex;
                let areaIndex = this.library.findIndex(area => {
                    packageIndex = area.packages.findIndex(package_ => {
                        setIndex = package_.sets.findIndex(set => {
                            gameIndex = set.games.findIndex(game => {
                                return game.id === this.game.id;
                            });
                            return gameIndex !== -1;
                        });
                        return setIndex !== -1;
                    });
                    return packageIndex !== -1;
                });

                let previousGame = this.library[areaIndex].packages[packageIndex].sets[setIndex].games[gameIndex - 1];

                // Check if there is element before
                if (previousGame !== undefined) {

                    let previousGameNumberInOrder = previousGame.number_in_order;
                    let currentGameNumberInOrder = this.game.number_in_order;

                    // Replace order number
                    this.game.number_in_order = previousGameNumberInOrder;
                    previousGame.number_in_order = currentGameNumberInOrder;

                    // Update library variable
                    this.library[areaIndex].packages[packageIndex].sets[setIndex].games[gameIndex] = previousGame;
                    this.library[areaIndex].packages[packageIndex].sets[setIndex].games[gameIndex - 1] = this.game;
                    this.eventHub.$emit('game-library-updated', this.library);
                }
            },

            moveDown() {
                // Get index of element
                let setIndex;
                let packageIndex;
                let gameIndex;
                let areaIndex = this.library.findIndex(area => {
                    packageIndex = area.packages.findIndex(package_ => {
                        setIndex = package_.sets.findIndex(set => {
                            gameIndex = set.games.findIndex(game => {
                                return game.id === this.game.id;
                            });
                            return gameIndex !== -1;
                        });
                        return setIndex !== -1;
                    });
                    return packageIndex !== -1;
                });

                let nextGame = this.library[areaIndex].packages[packageIndex].sets[setIndex].games[gameIndex + 1];

                // Check if there is element after
                if (nextGame !== undefined) {

                    let nextGameNumberInOrder = nextGame.number_in_order;
                    let currentGameNumberInOrder = this.game.number_in_order;

                    // Replace order number
                    this.game.number_in_order = nextGameNumberInOrder;
                    nextGame.number_in_order = currentGameNumberInOrder;

                    // Update library variable
                    this.library[areaIndex].packages[packageIndex].sets[setIndex].games[gameIndex] = nextGame;
                    this.library[areaIndex].packages[packageIndex].sets[setIndex].games[gameIndex + 1] = this.game;
                    this.eventHub.$emit('game-library-updated', this.library);
                }
            },

            showGameChangelog(game) {
                this.eventHub.$emit('game-library-show-element-changelog', 'game', game);
            },

        },

    }
</script>

<style scoped>

</style>
